import { useEffect, useState } from "react";
import axios from "axios";
import CommitteeMembersEditor from "./CommitteeMembersEditor";
import { confirmSwal } from "../utils/confirm";
import { toast } from "react-toastify";

import { auth } from "../firebase";

export default function AdminCommittees() {
    const [committees, setCommittees] = useState([]);
    const [loading, setLoading] = useState(true);
    const [newName, setNewName] = useState("");

    useEffect(() => {
        const fetchCommittees = async () => {
            try {
                const token = await auth.currentUser.getIdToken();
                const res = await axios.get("/api/committees", {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });
                setCommittees(res.data);
            } catch (error) {
                console.error("Error fetching committees:", error);
                toast.error("Error fetching committees");
            } finally {
                setLoading(false);
            }
        };
        
        fetchCommittees();
    }, []);

    const addCommittee = async () => {
        if (!newName.trim()) return toast.warn("Committee name cannot be empty");

        try {
            const token = await auth.currentUser.getIdToken();
            const res = await axios.post("/api/committees", { name: newName.trim() }, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            setCommittees([res.data, ...committees]);
            setNewName("");
        } catch {
            toast.error("Error adding committee");
        }
    };

    const deleteCommittee = async (id, name) => {
        const ok = await confirmSwal({
            title: `Delete committee ${name}?`,
            text: "Once deleted it cannot be restored.",
            icon: "warning",
            confirmText: "Delete",
            confirmColor: "#d33",
        });
        if (!ok) return;

        try {
            const token = await auth.currentUser.getIdToken();
            await axios.delete(`/api/committees/${id}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            setCommittees(committees.filter(c => c._id !== id));
        } catch {
            toast.error("Error deleting committee");
        }
    };

    if (loading) return <p>Loading committees...</p>;

    return (
        <div className="container">
            <p className="text-body-secondary">This is where you can create groups to form committees. After creating a committee, you can add members from the directory and specify their roles.</p>

            <div className="d-flex mb-3 gap-2">
                <input
                    type="text"
                    className="form-control"
                    placeholder="New committee name"
                    value={newName}
                    onChange={(e) => setNewName(e.target.value)}
                />
                <button className="btn btn-admin" onClick={addCommittee}>
                    +
                </button>
            </div>

            <ul className="list-group">
                {committees.map((c) => (
                    <li key={c._id} className="list-group-item">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                            <strong>{c.name}</strong>
                            <button className="btn btn-outline-secondary btn-sm" onClick={() => deleteCommittee(c._id, c.name)}>
                                Delete
                            </button>
                        </div>

                        <CommitteeMembersEditor committee={c} />
                    </li>
                ))}
            </ul>
        </div>
    );
}
